/**
 * Pure row-selection helpers shared by `FlowTable` and the V2 `LedgerTable`
 * (plan 2026-09-27-007 D5/U1). Glaze-free and React-free by design.
 */

/**
 * Shift-click range resolution (U3 / R1) — the anchor is FlowTable's own
 * last-explicitly-toggled-row state, the order is the CURRENTLY RENDERED
 * row order (`orderedIds`, straight off the `rows` prop). Falls back to a
 * single-row selection when the anchor or target can't be located in the
 * current order (e.g. the anchor scrolled off a filtered/paginated set) —
 * silently degrading to "select just this row" rather than throwing or
 * selecting nothing.
 */
export function computeRangeIds(orderedIds: string[], anchorId: string | null, targetId: string): string[] {
  const targetIndex = orderedIds.indexOf(targetId);
  if (targetIndex === -1) return [targetId];
  const anchorIndex = anchorId ? orderedIds.indexOf(anchorId) : -1;
  if (anchorIndex === -1) return [targetId];
  const [lo, hi] = anchorIndex <= targetIndex ? [anchorIndex, targetIndex] : [targetIndex, anchorIndex];
  return orderedIds.slice(lo, hi + 1);
}

/**
 * Whether a checkbox change came from a shift-click. Glaze's `Checkbox` is Base UI's:
 * `onCheckedChange(checked, eventDetails)` where `eventDetails.event` is the native event
 * that caused the change. Anything that isn't a mouse/keyboard event (or missing details) is
 * "not shift", so the caller falls back to a plain single toggle.
 */
export function isShiftFromCheckboxEvent(eventDetails: { event: Event } | undefined): boolean {
  const event = eventDetails?.event;
  return (event instanceof MouseEvent || event instanceof KeyboardEvent) && event.shiftKey;
}
